import React from "react";
import { VStack, Divider } from "@chakra-ui/react";
import KYDRadioCard from "./KYDRadioCard";

interface RadioOption {
  value: string;
  title: string;
  description: string;
  content?: React.ReactNode;
}

interface KYDRadioGroupProps {
  options: RadioOption[];
  value?: string;
  onChange: (value: string) => void;
  name: string;
  isDisabled?: boolean;
}

const KYDRadioGroup: React.FC<KYDRadioGroupProps> = ({
  options,
  value,
  onChange,
  name,
  isDisabled = false,
}) => {
  return (
    <VStack w="full" spacing={2}>
      {options.map((option, index) => (
        <React.Fragment key={option.value}>
          <KYDRadioCard
            title={option.title}
            description={option.description}
            value={option.value}
            isSelected={value === option.value}
            isDisabled={isDisabled}
            onChange={onChange}
            name={name}
          >
            {option.content}
          </KYDRadioCard>
        </React.Fragment>
      ))}
    </VStack>
  );
};

export default KYDRadioGroup;
